import styled, { css } from 'styled-components';
import { Result } from 'antd';

export const ResultContainer = styled(Result)`
    ${({ theme }) => css`
        padding: 0;
        .ant-result-extra {
            display: flex;
            justify-content: center;
            margin-top: 48px;
        }

        .ant-result-title {
            margin-bottom: 16px;
            max-width: 280px;
            margin-inline: auto;
        }

        .ant-result-subtitle {
            margin-inline: 8px;
        }

        @media (${theme.sizes.mediaQueries.desktopMin}) {
            max-width: 600px;
            padding: 48px 32px;

            .ant-result-subtitle {
                margin-inline: 32px;
            }
        }
    `}
`;
